import React, { useEffect } from 'react';
import { Map } from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import {
  Node,
  Taxonomy as TaxonomyTerm,
  entityGetByPath,
  ContextualActionsWrapper,
  Profile,
  referenceLoadingReset,
} from '@uncinc/react-drupal-core';

import {
  Container,
  usePrevious,
} from '@uncinc/uncinc-react-kitchen-sink';

import Page from '../Page';
import NotFound from '../NotFound';

const ENTITY_TYPE_TAXONOMY = 'taxonomy_term';
const HTTP_STATUS_CLIENT_ERROR_PREFIX = '4';
const HTTP_STATUS_SERVER_ERROR_PREFIX = '5';
const VARIANT_CAMPAIGN = 'campaign';
const VARIANT_PRIVACY = 'privacy';
const VARIANT_PRIVACY_NODE_ID = 31292;


const Entity = () => {
  const dispatch = useDispatch();

  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));

  const prevPath = usePrevious(path);
  const entityNotLoaded = !entityType || !entityId;
  const pathIsDifferentAndHasEntity =
    (path !== prevPath && typeof prevPath !== 'undefined') &&
    (typeof entityStatus !== 'undefined' && entityStatus !== null);

  let variant;
  const campaign = childEntity.getIn(['field_campaign']);
  if (campaign && campaign.size > 0) {
    variant = VARIANT_CAMPAIGN;
  } else if (childEntity.getIn(['nid', 0, 'value']) === VARIANT_PRIVACY_NODE_ID) {
    variant = VARIANT_PRIVACY;
  }

  useEffect(() => {
    if (entityNotLoaded || (!entityNotLoaded && pathIsDifferentAndHasEntity)) {
      dispatch(referenceLoadingReset());
      dispatch(entityGetByPath(path));
    }
  }, [dispatch, entityNotLoaded, pathIsDifferentAndHasEntity, path]);

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }

  if (
    (String(entityStatus).charAt(0) === (HTTP_STATUS_CLIENT_ERROR_PREFIX || HTTP_STATUS_SERVER_ERROR_PREFIX)) ||
    entityType === ENTITY_TYPE_TAXONOMY ||
    (entityExists === false && String(entityStatus).charAt(0) === (HTTP_STATUS_SERVER_ERROR_PREFIX))
  ) {
    return (
      <Container>
        <NotFound entityStatus={entityStatus} entityType={entityType} />
      </Container>
    );
  }

  return (
    <ContextualActionsWrapper>
      <Page title={childEntity.getIn(['title', 0, 'value'], '')}>
        {entityType === 'node' && (
          <Node root entity={childEntity} variant={variant} />
        )}
        {entityType === 'taxonomy_term' && (
          <TaxonomyTerm root entity={childEntity} />
        )}
        {entityType === 'profile' && (
          <Profile root entity={childEntity} />
        )}
      </Page>
    </ContextualActionsWrapper>
  );
};

export default Entity;
